import React from 'react';
import reqwest from 'reqwest';
import swal from 'sweetalert';

import settings from '../../../../../settings';

import RightSide from '../../../../components/FormArea/RightSide';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import Editor from '../../../../components/Editor';
import Input from '../../../../components/Inputs/Input';
import ContentBox from '../../../../components/FormArea/ContentBox';
import { faTimes, faSave, faTrash } from '@fortawesome/pro-solid-svg-icons';
import DataContainer from '../../../../logic/dataContainer';

class EMailMacrosDetails extends React.Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(new RegExp(`/${props.match.params.id}$`), '');

    this.state = {
      loading: true,
    };

    const EMailMacroPromise = reqwest({
      method: 'GET',
      url: settings.systemmanagement.emailmacro.get,
      contentType: 'JSON',
      data: {
        Token: localStorage.getItem('token'),
        Guid: props.match.params.id,
      },
    }).then(eMailMacroResponse => {
      this.container = new DataContainer(eMailMacroResponse);
    });

    Promise.all([EMailMacroPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  save = () => {
    const EMailMacro = this.container.getStringified();

    reqwest({
      method: 'POST',
      url: settings.systemmanagement.emailmacro.save,
      data: {
        Token: localStorage.getItem('token'),
        EMailMacro,
      },
    }).then(() => {
      swal({
        title: 'Erfolg!',
        text: 'Das E-Mail MaKro wurde erfolgreich gespeichert.',
        icon: 'success',
      });
      this.props.history.replace(this.parentRoute);
    });
  };

  delete = () => {
    swal({
      title: 'Sind Sie sich sicher?',
      text: 'Möchten Sie dieses E-Mail Makro wirklich löschen?',
      icon: 'warning',
      buttons: ['Abbrechen', 'Löschen'],
      dangerMode: true,
    }).then(willDelete => {
      if (willDelete) {
        reqwest({
          method: 'POST',
          url: settings.systemmanagement.emailmacro.delete,
          data: {
            Guid: this.container.get('Basic', 'Guid'),
          },
        }).then(() => {
          swal({
            title: 'Erfolg!',
            text: 'Das E-Mail Makro wurde erfolgreich gelöscht.',
            icon: 'success',
          });
          this.props.history.replace(this.parentRoute);
        });
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='E-Mail Makro'>
            <Input
              type='text'
              label='Makro Titel:'
              validator={[]}
              onChange={value => {
                this.dataContainer.set('Generals', 'Title')(value);
              }}
              defaultValue={this.dataContainer.get('Generals', 'Title')}
              name='Title'
            />
            <Input
              type='text'
              label='Betreff:'
              validator={[]}
              onChange={value => {
                this.dataContainer.set('Generals', 'Subject')(value);
              }}
              defaultValue={this.dataContainer.get('Generals', 'Subject')}
              name='Subject'
            />
            <Editor
              onChange={value => {
                this.dataContainer.set('Generals', 'Body')(value);
              }}
              editable
              macroPlaceholder={this.state.macroPlaceholder}
              updateConfig={options => {
                return {
                  ...options,
                  toolbarButtons: [
                    ...options.toolbarButtons,
                    ...['|'],
                    ...this.state.macroPlaceholder.map(placeholder => {
                      return placeholder.title;
                    }),
                  ],
                };
              }}
            >
              {this.dataContainer.get('Generals', 'Body')}
            </Editor>
          </ContentBox>
        </div>
        <RightSide>
          <Button big type='danger' icon={faTrash} onClick={this.delete}>
            Löschen
          </Button>
          <Button big icon={faTimes} to={this.parentRoute}>
            Abbrechen
          </Button>
          <Button big type='primary' icon={faSave} onClick={this.save}>
            Speichern
          </Button>
        </RightSide>
      </>
    );
  }
}

export default EMailMacrosDetails;
